import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { VehicleFingerprintContext } from '../../vehicle-fingerprint.models';
import { formatFingerprintMetric } from '../../vehicle-fingerprint.utils';

@Component({
  selector: 'app-vehicle-fingerprint-behavioral-features',
  templateUrl: './behavioral-features.component.html',
  styleUrls: ['../../summary-panels.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VehicleFingerprintBehavioralFeaturesComponent {
  @Input() context: VehicleFingerprintContext = { summary: null, unitId: '' };

  readonly formatValue = formatFingerprintMetric;
  readonly metrics = [
    { field: 'fDailyStopCountMean', label: 'تعداد توقف روزانه', decimals: 1, unit: '' },
    { field: 'fSpeedP95', label: 'سرعت P95', decimals: 1, unit: 'km/h' },
    { field: 'fSpeedMax', label: 'حداکثر سرعت', decimals: 1, unit: 'km/h' },
    { field: 'fDailyEngineOnHours', label: 'ساعات روشن بودن موتور', decimals: 2, unit: 'ساعت' },
    { field: 'fNightActivityRatio', label: 'فعالیت شبانه', decimals: 2, unit: '' },
  ] as const;
}
